import { getLocalizedStrings } from '../profileSettingsLocalizedStrings';
import classes from './notificationSettings.scss';
import VoicePreferences from './Presentational/VoicePreferences';
import TextBox from "./Presentational/addVoiceTextBox";
import ViewAllVoice from './viewAllVoice';
class NotificationVoiceSettings extends React.Component{

  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings('NotificationSettings');
    this.state = {
      preferenceError:[],removeVoicePressed:false,
      voiceErr:false,lastEAPreference:false,removeVoice:'',phoneNo:'',isError:false,
      editButtonPress:false,editVoice:"", addIconPress:false,enteredVoice:"",voiceExistErrMsg:"",
      cancelButtonPress:false, textPreferenceIndicator:null,
      addVoiceExistErrMsg:"",encEditVoiceValue:"",seqNo:null,viewAllVoice:false,
      removeButtonPress:false,modifyVoiceError:"",newEditVoice:"",voicePrefErr:false,disabledAdd:true,isVoiceInvalid:false,
      inputVoice:"",isNewVoiceValid:"",addCancelButtonPress:false, validationType:"phone",maxInputLength:13,disabledVoice:"",
      radioButton: {  phoneType:'', outlineStyle: '', validStyle: '', labels: [this.strings.mobileRadio, this.strings.landlineRadio]},  
    };
    this.addIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Add.svg';
    this.voiceIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOn.svg';
    this.warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
  }
  phoneTypeHandler = (event) => {
    const updatedState = { ...this.state };
    updatedState.radioButton.phoneType = event.currentTarget.value;
    this.setState(updatedState);
  }
  handleCloseClick = () => {
    this.setState({ verifyPhone: false });
  }
  getEnrollDetails(bpNumber,encryptedvalue){
    app.profileSettingsService.getEnrollDetails(bpNumber,encryptedvalue,"PHONE").then((response) => {
      if (response.errorCode !== undefined && response.errorCode !== '') {
        //err
      } else {
        this.setPreference(response.impactedDevice, response.lastEAPreference);  
      if(this.state.preferenceError.length>0 && this.state.removeVoice){
    
        this.setState({voiceErr:true}) ;}
        if(this.state.preferenceError.length>0 && this.state.encEditVoiceValue){
    
          this.setState({voicePrefErr:true}) ;}
     
      } });
  
  }
  setPreference(preferences, lastEAPreference) {
    const updatedState = { ...this.state };
    updatedState.preferenceError = [];
    updatedState.lastEAPreference = lastEAPreference;
    if(lastEAPreference && this.state.removeVoice){
      updatedState.preferenceError.push('Emergency Alerts');
    }
    else {
    preferences.map((preference) => {
      if (preference.category === 'DEMR' && preference.messageType === 'CPP1') {
        updatedState.preferenceError.push('Critical Peak Pricing Notifications');
      } else if (preference.category === 'PROG' && preference.messageType === 'BUDA') {
        updatedState.preferenceError.push('Budget Assistance Notifications');
      }
      else if (preference.category === 'OUTG' && preference.messageType === 'OUTG') {
        updatedState.preferenceError.push('Repair and Maintenance Alerts');
      }
      else if (preference.category === 'OUTG' && preference.messageType === 'EMRG') {
      updatedState.preferenceError.push('Emergency Alerts');
      }
    });
  }
    updatedState.preferenceError = [...new Set(updatedState.preferenceError)];
    this.setState(updatedState);
  }
  //remove handler is used for handling the functionality of clicking on Cross button
  removeHandler(e,encryptedvalue){
    const updatedState={...this.state};
    updatedState.voiceErr=false;
    updatedState.removeVoicePressed=true;
    updatedState.addIconPress=false;
    updatedState.editButtonPress=false;
    updatedState.removeVoice=encryptedvalue;
    this.getEnrollDetails(this.props.bpNumber,encryptedvalue);
    this.setState(updatedState);
  }
  //used for clicking on cancel
  removeCancelHandler(){
    const updatedState={...this.state};
    updatedState.removeVoicePressed=false;
    this.setState(updatedState);
  }
  //Delete button click functionality
  deleteButtonHandler(e,sn){
   
    let reqObj={ 'deviceType':'voice','addressGuid':this.props.data.addressGuid,'modifiedValue': this.state.removeVoice,
      'sequenceNumber': sn};
    app.profileSettingsService.modifyCustomerPreference(this.props.bpNumber, reqObj, null, true).then(response => {
      if (response.errorCode && response.errorCode !== ''){
        this.setState({modifyVoiceError: true});
      }else if(this.props.data.duplicatePhoneList.has(sn)) {
          let duplicateNumber = this.props.data.duplicatePhoneList.get(sn);
          reqObj = { 'deviceType':'voice','addressGuid':this.props.data.addressGuid,'modifiedValue': duplicateNumber.encryptedvalue,
          'sequenceNumber': duplicateNumber.sequenceNumber};
          app.profileSettingsService.modifyCustomerPreference(this.props.bpNumber, reqObj, null, true).then(response => {
            this.props.refreshNotification();
            const updatedState = { ...this.state };
            updatedState.removeVoicePressed=false;
            updatedState.modifyVoiceError=false;
            this.setState(updatedState);
          });
        } else {
          this.props.refreshNotification();
          const updatedState = { ...this.state };
          updatedState.removeVoicePressed=false;
          updatedState.modifyVoiceError=false;
          this.setState(updatedState);
        }
    });
  }
  refreshNotification(){
    app.profileSettingsService.getNotificationDetails(this.mainBpNumber).then((response) => {
      if (response.errorCode !== undefined && response.errorCode !== '') {
        this.setState({emailIds: '', msCallErr:true });
      }
      else{
        let list = response.phoneNumbers.filter(record => record.indicatorSmsEnabled === 'X');
      this.setState({text :list,emailIds: response.emailAddresses,voice: response.phoneNumbers,addressGuid:response.addressGuid,msCallErr:false});
      }
    });
  }
  editHandler(e,text,record){
    /* Sonar Cube fix 
          Done by : Keerthi VL
          Date : 23-01-2023
      */
    window.aUtils.sendAAEvent("button","voiceEdit");
    const updatedState = { ...this.state };
    updatedState.editButtonPress = true, 
    updatedState.editVoice=text; 
    updatedState.removeVoicePressed=false;
    updatedState.encEditVoiceValue=record.encryptedvalue;
    updatedState.seqNo=record.sequenceNumber;
    updatedState.textPreferenceIndicator=record.indicatorSmsEnabled;//to check text pref exists in voice array. 
    updatedState.voiceExistErrMsg="";
    updatedState.modifyVoiceError=false;
    updatedState.isVoiceInvalid=false;
    updatedState.newEditVoice="";
    updatedState.voicePrefErr=false, updatedState.radioButton.phoneType = this.props.isLandlineOrMobile(record.indicatorTelephone,false); //directly do here 
    updatedState.addIconPress=false, updatedState.disabledVoice=false, this.setState(updatedState);
    this.getEnrollDetails(this.props.bpNumber,record.encryptedvalue);
    
}
cancelButtonHandler = () => {
  const updatedState = { ...this.state };
  updatedState.cancelButtonPress = true;
  updatedState.editButtonPress = false;
  updatedState.voiceExistErrMsg="";
  this.setState(updatedState);
  
}
voiceCallback(voiceValue){
  const updatedState = { ...this.state };
  updatedState.enteredVoice=voiceValue;
  updatedState.voiceExistErrMsg="";
  this.setState(updatedState,
    ()=>{this.isValidatedVoice(this.state.enteredVoice);});
}
addIconHandler(){ 
  const updatedState = { ...this.state };
  updatedState.addIconPress=true, updatedState.phoneType=this.strings.mobileRadio, updatedState.editButtonPress=false, updatedState.removeButtonPress=false, updatedState.addVoiceExistErrMsg="", updatedState.addTextError=false, updatedState.disabledAdd=true, this.setState(updatedState);
}
addVoiceCallback(newVoice,isNewVoiceValid){
  const updatedState = { ...this.state };
  updatedState.inputVoice=newVoice,updatedState.isNewVoiceValid=isNewVoiceValid;
  updatedState.addVoiceExistErrMsg="";
  this.setState(updatedState,
    ()=>{this.isValidatedVoice(this.state.inputVoice);});
 
}
isValidatedVoice(ph){
  if(ph.length===12){
   const updatedState = { ...this.state };
    updatedState.disabledAdd=false;
    updatedState.isVoiceInvalid=false;
    updatedState.disabledVoice=false;
    this.setState(updatedState);

  }
  else{
     const updatedState = { ...this.state };
      updatedState.disabledAdd=true;
      updatedState.isVoiceInvalid=true;
      updatedState.disabledVoice=true;
      this.setState(updatedState);
  }

}

addButtonHandler(){
  this.setState({disabledAdd:true, addTextError:false }); // need to check 
window.aUtils.sendAAEvent("button","addVoice");
let enteredValue = this.state.inputVoice.split("-").join("");
app.profileSettingsService.getEncryptedPhoneNumber(enteredValue).then(response=>{
if(!this.ifPhoneNoExists(response.phoneNumber)) {
  let encPhoneNumber;
  encPhoneNumber=response.phoneNumber;
  this.twoFAVerification(app.appUtil.maskPhoneNumberWithhyphenX(this.state.inputVoice), 'Phone','I',encPhoneNumber,'');
}else{
  this.setState({addVoiceExistErrMsg:this.strings.textExistMsg});
}
});}
ifPhoneNoExists(phoneNo) {
 
  let phoneExist=false;
  _.each(this.props.data.voice, function (record) {
    if (record.encryptedvalue === phoneNo)
      phoneExist=true;});
    return phoneExist;
  }
addCancelButtonHandler(){
  const updatedState={...this.state};
    updatedState.addCancelButtonPress=true, updatedState.addIconPress=false, updatedState.addVoiceExistErrMsg="", updatedState.disabledAdd=true, this.setState(updatedState);
}

saveButtonHandler(){
this.setState({disabledVoice:true});
window.aUtils.sendAAEvent("button","editVoiceSave"); 
const updatedState={...this.state};

if(this.state.enteredVoice!==""){
let text=this.state.enteredVoice;
let enteredValue = text.split("-").join("");
  app.profileSettingsService.getEncryptedPhoneNumber(enteredValue).then(response=>{  
    if(!this.ifPhoneNoExists(response.phoneNumber)) {
    updatedState.modifyVoiceError=false,updatedState.editButtonPress = false,updatedState.addIconPress=false,updatedState.newEditVoice=this.state.enteredVoice,updatedState.enteredVoice="",updatedState.voiceExistErrMsg="",this.setState(updatedState);
    this.twoFAVerification(app.appUtil.maskPhoneNumberWithhyphenX(this.state.newEditVoice),'Phone','U',response.phoneNumber,this.state.seqNo,this.state.radioButton.phoneType);
    }else{
     this.setState({voiceExistErrMsg:this.strings.textExistMsg});  
    }});

}
else{
  this.setState({voiceExistErrMsg:this.strings.textExistMsg}); 
 }
}
twoFAVerification = (value, showModal, changeFlag, encryptedvalue,sequenceNumber,phoneType) => {
  const updatedState = { ...this.state };
  updatedState.addIconPress = false,updatedState.editButtonPress=false;
  this.setState(updatedState,
    () => { this.props.verifyHandler(value, showModal, changeFlag, encryptedvalue,sequenceNumber,phoneType); });
}
  render(){
    return(
      <div>
        

        <div className={classes.box}>
          <div className={classes.row}>
            <div  className={classes.rowheader}>
            <span><img src={this.voiceIcon} alt='Voice Icon' /></span>                 
            <span className={classes.count}>{this.strings.phone} ({this.props.data.voice.length})</span> 
            {this.props.data.voice.length>3 ? <div className={classes.viewAllButtonPadding}><button className={classes.viewAllButton}  id="viewAllVoice" onClick={this.props.viewAllVoice.bind(this)}  >{this.strings.viewall}</button></div>:null}
            </div>
            <div className={classes.dividerLine} /> 
            
            <VoicePreferences isLandlineOrMobile={this.props.isLandlineOrMobile} disabledAdd={this.state.disabledAdd}   verificationSuccessful={this.props.verificationSuccessful} phoneTypeHandler={this.phoneTypeHandler}   verifyHandler={this.twoFAVerification}  type={this.state.validationType} maxLength={this.state.maxInputLength} preferenceDetails={this.state.preferenceDetails} editHandler={this.editHandler.bind(this)} editButton={this.state.editButtonPress} editVoice={this.state.editVoice} 
            newText={this.state.newEditVoice} voiceCallback={this.voiceCallback.bind(this)} cancelButtonHandler={this.cancelButtonHandler.bind(this)} saveButtonHandler={this.saveButtonHandler.bind(this)} voiceExistErrMsg={this.state.voiceExistErrMsg} modifyVoiceError={this.state.modifyVoiceError}
               data={this.props.data} CACTCount={this.props.CACTCount} voiceData={this.state} removeHandler={this.removeHandler.bind(this)} removeCancelHandler={this.removeCancelHandler.bind(this)} deleteButtonHandler={this.deleteButtonHandler.bind(this)}
                radioButton={this.state.radioButton}  voicePrefErr={this.state.voicePrefErr} encEditVoiceValue={this.state.encEditVoiceValue} placeHolder={!_.isEmpty(this.state.editVoice) ? this.state.editVoice : 'Enter Phone'} disabledVoice={this.state.disabledVoice} /> 
                {this.state.addIconPress ? 
                <div>
                  <div className={classes.box}>
                    <span lassName={classes.textBox}>
                   
                <TextBox id='textInput'
                    type={this.state.validationType}
                    maxLength={this.state.maxInputLength}
                    validator={app.appUtil.validator} placeholder={"Enter phone"} addVoiceCallback={this.addVoiceCallback.bind(this)} emailValue={""} autoComplete="sceVoiceProfile" />
                <span className={classes.saveCancelButtonAlign}>
                <button className={this.state.disabledAdd ?  classes.disabledAddButtonEmail : classes.AddButtonEmail} onClick={this.addButtonHandler.bind(this)} disabled={this.state.disabledAdd}>{this.strings.AddButtonValue}</button>
                <button className={classes.CancelButtonEmail} onClick={this.addCancelButtonHandler.bind(this)}>{this.strings.CancelButtonValue}</button>
                </span>
                </span>
                {this.state.addVoiceExistErrMsg ? <span className={classes.errMsg}>{this.state.addVoiceExistErrMsg}</span>: null}
                {this.state.addTextError ? <span className={classes.errMsg}>{this.strings.errorMsg}</span>: null} 
                <div className={classes.dividerLine} /> 
                </div>
                </div>: null}
            <div  className={classes.adding}>
            <button className={classes.addButton} onClick={this.addIconHandler.bind(this)}>
              <img src={this.addIcon} alt='Add Icon' onClick={this.addIconHandler.bind(this)} /> &nbsp;
              <span  className={classes.addnew}>{this.strings.addPhone}</span>
            </button>
            </div>   
            </div>
        </div>
      </div>

    );
  }
}
export default NotificationVoiceSettings;